/* eslint-disable */
import { TextPosition, TextSearchResults, HelperMethods } from '../index';
import { beforeXmlHttpRequestSend } from './../../index';
import { Dictionary } from '../../base/dictionary';
import { TextElementBox, ErrorTextElementBox, TableCellWidget, FieldElementBox, ParagraphWidget, TableWidget, ShapeElementBox, GroupShapeElementBox, FootnoteElementBox, BookmarkElementBox } from '../viewer/page';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * The spell checker module
 */
export class SpellChecker {
    constructor(documentHelper) {
        this.langIDInternal = 0;
        /**
         * Specifies whether spell check has to be performed or not.
         */
        this.enableSpellCheckInternal = true;
        /**
         * @private
         */
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.uniqueSpelledWords = {};
        /**
         * Every time rendering text elementbox we are checking the key length of the uniqueSpelledWords object. This causes performance issue So optimizing it.
         */
        this.uniqueSpelledWordsCount = 0;
        this.spellSuggestionInternal = true;
        /**
         * @private
         */
        this.uniqueKey = '';
        this.removeUnderlineInternal = false;
        this.combinedElements = [];
        /**
         * @default 1000
         */
        this.uniqueWordsCountInternal = 15000;
        this.performOptimizedCheck = true;
        /**
         * @private
         */
        this.handleErrorElements = [];
        /**
         * @private
         */
        this.isChangeAll = false;
        /**
         * @private
         */
        this.skipChangeDetection = false;
        this.pageCacheIndex = [];
        this.ignoreUppercaseInternal = false;
        this.enableUserDictionaryInternal = false;
        this.documentHelper = documentHelper;
        this.errorWordCollection = new Dictionary();
        this.uniqueWordsCollection = new Dictionary();
        this.errorSuggestions = new Dictionary();
        this.ignoreAllItems = [];
        this.uniqueSpelledWords = {};
        if (!isNullOrUndefined(this.documentHelper) && !isNullOrUndefined(this.documentHelper.owner)) {
            this.textSearchResults = new TextSearchResults(this.documentHelper.owner);
            this.uniqueKey = this.documentHelper.owner.element.id + '_' + this.createGuid();
        }
    }
    /**
     * Gets a value indicating whether to ignore words written in uppercase during spell check.
     *
     * @aspType bool
     * @returns {boolean} Returns ignoreUppercase
     */
    get ignoreUppercase() {
        return this.ignoreUppercaseInternal;
    }
    /**
     * Sets a value indicating whether to ignore words written in uppercase during spell check.
     *
     * @aspType bool
     */
    set ignoreUppercase(value) {
        this.ignoreUppercaseInternal = value;
    }
    /**
     * Gets the boolean indicating whether user-specific dictionaries are enabled.
     *
     * If true, maintains a user-specific custom dictionary file for spell checking.
     * If false, maintains a common custom dictionary for all users.
     *
     * @aspType bool
     * @returns {boolean} Returns enableUserDictionary
     */
    get enableUserDictionary() {
        return this.enableUserDictionaryInternal;
    }
    /**
     * Sets the boolean indicating whether user-specific dictionaries are enabled.
     *
     * If true, maintains a user-specific custom dictionary file for spell checking.
     * If false, maintains a common custom dictionary for all users.
     *
     * @aspType bool
     */
    set enableUserDictionary(value) {
        this.enableUserDictionaryInternal = value;
        // Reset spell checker collections when switching users with user dictionary enabled
        // because spelling errors need to be re-evaluated based on the user's specific or custom dictionary
        this.documentHelper.triggerSpellCheck = true;
        this.resetSpellCheckState();
        this.viewer.updateScrollBars();
        this.documentHelper.triggerSpellCheck = false;
    }
    /**
     * Gets module name.
     */
    getModuleName() {
        return 'SpellChecker';
    }
    /**
     * Gets the boolean indicating whether optimized spell check to be performed.
     *
     * @aspType bool
     * @returns {boolean} Returns enableOptimizedSpellCheck
     */
    get enableOptimizedSpellCheck() {
        return this.performOptimizedCheck;
    }
    /**
     * Sets the boolean indicating whether optimized spell check to be performed.
     *
     * @aspType bool
     */
    set enableOptimizedSpellCheck(value) {
        this.performOptimizedCheck = value;
    }
    /**
     * Gets the spell checked Unique words.
     *
     * @aspType int
     */
    get uniqueWordsCount() {
        return isNullOrUndefined(this.uniqueWordsCountInternal) ? 0 : this.uniqueWordsCountInternal;
    }
    /**
     * Sets the spell checked Unique words.
     *
     * @aspType int
     */
    set uniqueWordsCount(value) {
        this.uniqueWordsCountInternal = value;
    }
    /**
     * Gets the languageID.
     *
     * @aspType int
     */
    get languageID() {
        return isNullOrUndefined(this.langIDInternal) ? 0 : this.langIDInternal;
    }
    /**
     * Sets the languageID.
     *
     * @aspType int
     */
    set languageID(value) {
        this.langIDInternal = value;
    }
    /**
     * Getter indicates whether suggestion enabled.
     *
     * @aspType bool
     */
    get allowSpellCheckAndSuggestion() {
        return this.spellSuggestionInternal;
    }
    /**
     * Setter to enable or disable suggestion
     *
     * @aspType bool
     */
    set allowSpellCheckAndSuggestion(value) {
        this.spellSuggestionInternal = value;
    }
    /**
     * Getter indicates whether underline removed for mis-spelled word.
     *
     * @aspType bool
     */
    get removeUnderline() {
        return this.removeUnderlineInternal;
    }
    /**
     * Setter to enable or disable underline for mis-spelled word
     *
     * @aspType bool
     */
    set removeUnderline(value) {
        this.documentHelper.triggerElementsOnLoading = true;
        this.documentHelper.triggerSpellCheck = true;
        this.removeUnderlineInternal = value;
        this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
        this.documentHelper.triggerElementsOnLoading = false;
        this.documentHelper.triggerSpellCheck = false;
    }
    /**
     * Getter indicates whether spell check has to be performed or not.
     *
     * @aspType bool
     */
    get enableSpellCheck() {
        return this.enableSpellCheckInternal;
    }
    /**
     * Setter to enable or disable spell check has to be performed or not
     *
     * @aspType bool
     */
    set enableSpellCheck(value) {
        this.enableSpellCheckInternal = value;
        this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
    }
    get viewer() {
        return this.documentHelper.owner.viewer;
    }
    /**
     * Method to manage replace logic
     *
     * @private
     */
    manageReplace(content, dialogElement, isChangeAll) {
        this.documentHelper.triggerSpellCheck = true;
        let exactText = '';
        let elementInfo;
        if (!isNullOrUndefined(dialogElement) && dialogElement instanceof ErrorTextElementBox) {
            const exactText = dialogElement.text;
            const isInHeaderFooter = dialogElement.start.currentWidget.paragraph.isInHeaderFooter;
            if (isInHeaderFooter) {
                let paragraphInfo = this.documentHelper.selection.getParagraphInfo(dialogElement.start);
                let endParagraphInfo = this.documentHelper.selection.getParagraphInfo(dialogElement.end);
                const startIndex = this.documentHelper.selection.getHierarchicalIndex(paragraphInfo.paragraph, paragraphInfo.offset.toString());
                const endIndex = this.documentHelper.selection.getHierarchicalIndex(endParagraphInfo.paragraph, endParagraphInfo.offset.toString());
                this.documentHelper.selection.start = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(startIndex);
                this.documentHelper.selection.end = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(endIndex);
            }
            else {
                this.documentHelper.selection.start = dialogElement.start.clone();
                this.documentHelper.selection.end = dialogElement.end.clone();
            }
            if (content !== 'Ignore Once') {
                if (this.documentHelper.selection.start.paragraph.isFieldCodeBlock) {
                    return;
                }
                content = this.manageSpecialCharacters(exactText, content);
                this.addRemovedElements(isChangeAll, dialogElement);
                this.documentHelper.owner.editorModule.insertTextInternal(content, true);
                this.documentHelper.selection.start.setPositionInternal(this.documentHelper.selection.end);
                this.documentHelper.clearSelectionHighlight();
                return;
            }
            else {
                this.currentContextInfo = { 'text': exactText, 'element': dialogElement };
            }
        }
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element instanceof ErrorTextElementBox && content !== 'Ignore Once') {
            const elementBox = this.currentContextInfo.element;
            exactText = this.currentContextInfo.element.text;
            this.documentHelper.selection.start = elementBox.start.clone();
            this.documentHelper.selection.end = elementBox.end.clone();
        }
        else {
            this.handleReplace(content);
        }
        if (content !== 'Ignore Once') {
            this.addRemovedElements(isChangeAll, dialogElement);
            this.documentHelper.owner.editorModule.insertTextInternal(content, true);
            if (isChangeAll && !isNullOrUndefined(this.currentContextInfo)) {
                this.removeErrorsFromCollection(this.currentContextInfo);
            }
            this.documentHelper.selection.start.setPositionInternal(this.documentHelper.selection.end);
            this.documentHelper.clearSelectionHighlight();
        }
        //this.documentHelper.owner.errorWordCollection.remove(content);
        this.documentHelper.triggerSpellCheck = false;
    }
    addRemovedElements(isChangeAll, dialogElement) {
        if (!isChangeAll) {
            if (this.handleErrorElements.indexOf(dialogElement) === -1) {
                this.handleErrorElements.push(dialogElement);
            }
            let start = this.documentHelper.selection.start;
            let end = this.documentHelper.selection.end;
            if (!this.documentHelper.selection.isForward) {
                start = this.documentHelper.selection.end;
                end = this.documentHelper.selection.start;
            }
            let startElement = start.currentWidget.getInline(start.offset, 0, false, true).element;
            const endElement = end.currentWidget.getInline(end.offset, 0, false, true).element;
            while (true) {
                if (this.handleErrorElements.indexOf(startElement) === -1) {
                    this.handleErrorElements.push(startElement);
                }
                if (startElement === endElement) {
                    break;
                }
                startElement = startElement.nextNode;
            }
        }
    }
    /**
     * Method to handle replace logic
     *
     * @private
     */
    handleReplace(content) {
        let startPosition = this.documentHelper.selection.start;
        const offset = startPosition.offset;
        const startIndex = 0;
        const startInlineObj = startPosition.currentWidget.getInline(offset, startIndex, false, true);
        const startOffset = startInlineObj.element.line.getOffset(startInlineObj.element, 0) + startInlineObj.element.length;
        if (startOffset === offset) {
            this.retrieveExactElementInfo(startInlineObj);
        }
        const exactText = startInlineObj.element.text;
        const startPattern = new RegExp('^[#\\@\\!\\~\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\'\\,\\<\\.\\>\\/\\?\\`\\s]+', 'g');
        let matches = [];
        let matchInfo;
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchInfo = startPattern.exec(exactText))) {
            matches.push(matchInfo);
        }
        if (content === 'Ignore Once') {
            this.handleIgnoreOnce(startInlineObj);
            return;
        }
        startPosition.offset = offset - startInlineObj.index;
        if (!isNullOrUndefined(matches) && matches.length > 0) {
            startPosition.offset += matches[0].toString().length;
        }
        startPosition.location = this.documentHelper.owner.selectionModule.getPhysicalPositionInternal(startPosition.currentWidget, startPosition.offset, true);
        startPosition = this.documentHelper.owner.searchModule.textSearch.getTextPosition(startPosition.currentWidget, startPosition.offset.toString());
        //startPosition.location = this.owner.selection.getPhysicalPositionInternal(span.line, offset, true);
        startPosition.setPositionParagraph(startPosition.currentWidget, startPosition.offset);
        const index = (startPosition.offset + startInlineObj.element.length) - startPosition.offset;
        let endOffset = startPosition.currentWidget.getOffset(startInlineObj.element, index);
        const lineWidget = startPosition.currentWidget;
        const endPattern = new RegExp('[#\\@\\!\\~\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\'\\,\\<\\.\\>\\/\\?\\s\\`]+$', 'g');
        matches = [];
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchInfo = endPattern.exec(exactText))) {
            matches.push(matchInfo);
        }
        if (!isNullOrUndefined(matches) && matches.length > 0) {
            endOffset -= matches[0].toString().length;
        }
        this.documentHelper.selection.end = this.documentHelper.owner.searchModule.textSearch.getTextPosition(lineWidget, endOffset.toString());
        this.documentHelper.selection.end.location = this.documentHelper.owner.selectionModule.getPhysicalPositionInternal(startPosition.currentWidget, endOffset, true);
        this.documentHelper.selection.end.setPositionParagraph(lineWidget, endOffset);
        this.currentContextInfo = { 'element': startInlineObj.element, 'text': startInlineObj.element.text };
    }
    /**
     * Method to retrieve exact element info
     *
     * @private
     */
    retrieveExactElementInfo(startInlineObj) {
        const nextElement = startInlineObj.element.nextElement;
        if (!isNullOrUndefined(nextElement) && nextElement instanceof TextElementBox) {
            let nextTextElBox = nextElement;
            if (nextTextElBox.text.trim() != "") {
                startInlineObj.element = nextElement;
            }
        }
    }
    /**
     * Method to handle to ignore error Once
     *
     * @private
     */
    handleIgnoreOnce(startInlineObj) {
        if (this.documentHelper.owner && this.documentHelper.owner.editorModule) {
            this.documentHelper.owner.editor.initHistory('IgnoreOnce');
        }
        const textElement = startInlineObj.element;
        // If text is split into multiple text elements, then we need to add ignoreOnceItems for all the text elements. So gets the start and end position of the text element and checks the same text exist which is in error element.
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element && this.currentContextInfo.element instanceof ErrorTextElementBox) {
            this.handleIgnoreOnceInternal(this.currentContextInfo.element, false);
        }
        else {
            const exactText = this.manageSpecialCharacters(textElement.text, undefined, true);
            if (textElement.ignoreOnceItems.indexOf(exactText) === -1) {
                textElement.ignoreOnceItems.push(exactText);
            }
            this.handleErrorElements.push(textElement);
        }
    }
    /**
     * Method to handle to ignore error Once intenral
     *
     * @private
     */
    handleIgnoreOnceInternal(errorElement, isundoing) {
        const startPosition = errorElement.start;
        const endPosition = errorElement.end;
        const inlineObj = startPosition.currentWidget.getInline(startPosition.offset, 0, false, true);
        let startInlineObj = inlineObj.element;
        let endInlineObj = endPosition.currentWidget.getInline(endPosition.offset, 0, false, true).element;
        this.handleErrorElements.push(errorElement);
        if (this.documentHelper.selection.start && this.documentHelper.selection.start.paragraph && !this.documentHelper.selection.start.paragraph.isInHeaderFooter) {
            while (true) {
                if (startInlineObj.text === "" || startInlineObj.text === " ") {
                    startInlineObj = startInlineObj.nextNode;
                    if (inlineObj.index > 0) {
                        inlineObj.index = inlineObj.index - 1;
                    }
                }
                else {
                    break;
                }
            }
            if (startInlineObj instanceof TextElementBox) {
                this.splitTextBoxElement(startInlineObj, inlineObj.index, errorElement.text.length + inlineObj.index);
            }
            const currentErrorElement = this.updateErroElement(errorElement);
            if (currentErrorElement) {
                startInlineObj = currentErrorElement;
                endInlineObj = currentErrorElement;
            }
        }
        while (true) {
            while (startInlineObj instanceof BookmarkElementBox) {
                startInlineObj = startInlineObj.nextNode;
                if (isNullOrUndefined(startInlineObj)) {
                    break;
                }
            }
            if (!isNullOrUndefined(startInlineObj)) {
                const exactText = this.manageSpecialCharacters(errorElement.text, undefined, true);
                const textIndex = startInlineObj && startInlineObj.ignoreOnceItems && startInlineObj.ignoreOnceItems.indexOf(exactText);
                if (isundoing) {
                    if (textIndex !== -1) {
                        startInlineObj.ignoreOnceItems.splice(textIndex, 1);
                    }
                }
                else {
                    if (textIndex === -1) {
                        startInlineObj.ignoreOnceItems.push(exactText);
                    }
                    this.handleErrorElements.push(startInlineObj);
                }
                if (startInlineObj === endInlineObj) {
                    break;
                }
                startInlineObj = startInlineObj.nextNode;
            }
            else {
                break;
            }
        }
    }
    /**
     * Method to handle ignore all items
     *
     * @private
     */
    handleIgnoreAllItems(contextElement) {
        const contextItem = (!isNullOrUndefined(contextElement)) ? contextElement : this.retriveText();
        const retrievedText = this.manageSpecialCharacters(contextItem.text, undefined, true);
        if (this.ignoreAllItems.indexOf(retrievedText) === -1) {
            this.ignoreAllItems.push(retrievedText);
            if (!isNullOrUndefined(contextItem.element)) {
                this.handleErrorCollection(contextItem.element);
            }
            this.documentHelper.clearSelectionHighlight();
        }
    }
    /**
     * Method to handle dictionary
     *
     * @private
     */
    handleAddToDictionary(contextElement) {
        const contextItem = (!isNullOrUndefined(contextElement)) ? contextElement : this.retriveText();
        const retrievedText = this.manageSpecialCharacters(contextItem.text, undefined, true);
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.callSpellChecker(this.languageID, retrievedText, false, false, true).then((data) => {
            if (!isNullOrUndefined(this.documentHelper)) {
                this.documentHelper.triggerSpellCheck = true;
                this.removeErrorsFromCollection(contextItem);
                this.ignoreAllItems.push(retrievedText);
                // Build casing variants to suppress: original, Capitalized (if lower), and UPPER
                const casingWords = [];
                const text = contextItem.text;
                if (!isNullOrUndefined(text) && text.length > 1) {
                    if (text === text.toLowerCase()) {
                        const formattedText = text.charAt(0).toUpperCase() + text.substring(1);
                        if (formattedText !== text) {
                            casingWords.push(formattedText);
                        }
                    }
                    const upperCaseText = text.toUpperCase();
                    if (upperCaseText !== text) {
                        casingWords.push(upperCaseText);
                    }
                }
                for (let i = 0; i < casingWords.length; i++) {
                    const word = casingWords[i];
                    if (this.ignoreAllItems.indexOf(word) === -1) {
                        this.ignoreAllItems.push(word);
                    }
                    if (this.errorWordCollection.containsKey(word)) {
                        const elements = this.errorWordCollection.get(word);
                        if (elements && elements.length > 0) {
                            this.removeErrorsFromCollection({ element: elements[0], text: word });
                        }
                    }
                }
                this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection, true);
                this.documentHelper.triggerSpellCheck = false;
            }
        });
    }
    splitTextBoxElement(inline, startIndex, endIndex) {
        this.skipChangeDetection = true;
        let currentElement = inline;
        let node = inline;
        let index = inline.line.children.indexOf(node);
        let paragraph = inline.paragraph;
        let textElement;
        let indexCountForRevision = 0;
        if (startIndex > 0) {
            indexCountForRevision += 1;
            textElement = new TextElementBox();
            textElement.characterFormat.copyFormat(inline.characterFormat);
            if (!isNullOrUndefined(inline.contentControlProperties)) {
                textElement.contentControlProperties = inline.contentControlProperties;
            }
            textElement.line = inline.line;
            textElement.text = inline.text.substr(startIndex, endIndex - startIndex);
            textElement.isRightToLeft = inline.isRightToLeft;
            this.updateErrorCollectionForSplitElement(inline, textElement, startIndex);
            index++;
            node.line.children.splice(index, 0, textElement);
            this.documentHelper.owner.editorModule.updateRevisionForFormattedContent(inline, textElement, indexCountForRevision);
            // currentElement = textElement;
            inline.isWidthUpdated = false;
        }
        if (endIndex < node.length) {
            indexCountForRevision += 1;
            textElement = new TextElementBox();
            textElement.characterFormat.copyFormat(inline.characterFormat);
            if (!isNullOrUndefined(inline.contentControlProperties)) {
                textElement.contentControlProperties = inline.contentControlProperties;
            }
            textElement.text = node.text.substring(endIndex);
            textElement.line = inline.line;
            this.updateErrorCollectionForSplitElement(inline, textElement, endIndex);
            textElement.isRightToLeft = inline.isRightToLeft;
            index++;
            node.line.children.splice(index, 0, textElement);
            this.documentHelper.owner.editorModule.updateRevisionForFormattedContent(inline, textElement, indexCountForRevision);
            inline.isWidthUpdated = false;
        }
        if (startIndex === 0) {
            inline.text = inline.text.substr(0, endIndex);
        }
        else {
            inline.text = inline.text.substr(0, startIndex);
        }
        this.documentHelper.layout.reLayoutParagraph(paragraph, inline.line.indexInOwner, 0, false, false);
        this.skipChangeDetection = false;
        return currentElement;
    }
    updateErroElement(errorElement) {
        const startPosition = errorElement.start;
        const endPosition = errorElement.end;
        for (let i = 0; i < startPosition.currentWidget.children.length; i++) {
            const errorCollection = startPosition.currentWidget.children[i].errorCollection;
            if (errorCollection && errorCollection.indexOf(errorElement) === 0) {
                return startPosition.currentWidget.children[i];
            }
        }
        return null;
    }
    /**
     * Method to append/remove special characters
     *
     * @private
     */
    manageSpecialCharacters(exactText, replaceText, isRemove) {
        if (!isNullOrUndefined(exactText)) {
            let isRemoveSpecChar = false;
            if (isNullOrUndefined(replaceText)) {
                isRemoveSpecChar = true;
                replaceText = exactText;
            }
            const pattern = new RegExp('^[#\\@\\!\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\\”\'\\,\\<\\.\\>\\/\\?\\`\\s\\’]+', 'g');
            let matches = [];
            let matchInfo;
            // eslint-disable  no-cond-assign
            while (!isNullOrUndefined(matchInfo = pattern.exec(exactText))) {
                matches.push(matchInfo);
            }
            if (matches.length > 0) {
                for (let i = 0; i < matches.length; i++) {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    const match = matches[i];
                    replaceText = (!isRemove) ? match[0] + replaceText : replaceText.replace(match[0], '');
                }
            }
            const endPattern = new RegExp('[#\\@\\!\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\\”\'\\,\\<\\>\\/\\?\\s\\`\\’]+$', 'g');
            matches = [];
            let originalText = replaceText;
            if (!isRemove) {
                originalText = exactText;
            }
            // eslint-disable  no-cond-assign
            while (!isNullOrUndefined(matchInfo = endPattern.exec(originalText))) {
                matches.push(matchInfo);
            }
            if (matches.length > 0) {
                for (let i = 0; i < matches.length; i++) {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    const match = matches[i];
                    replaceText = (!isRemove) ? replaceText + match[0] : replaceText.slice(0, match.index);
                }
            }
            // if the text contains zero width characters, remove them.
            const zeroWidthPattern = /[\u200B-\u200D\uFEFF]/g;
            replaceText = replaceText.replace(zeroWidthPattern, '');
        }
        return replaceText;
    }
    /**
     * Method to remove errors
     *
     * @private
     */
    removeErrorsFromCollection(contextItem) {
        if (!isNullOrUndefined(contextItem.text) && this.errorWordCollection.containsKey(contextItem.text)) {
            const textElement = this.errorWordCollection.get(contextItem.text);
            if (textElement.indexOf(contextItem.element) >= 0) {
                textElement.splice(textElement.indexOf(contextItem.element), 1);
            }
            if (textElement.length === 0) {
                this.errorWordCollection.remove(contextItem.text);
            }
        }
    }
    /**
     * Method to retrieve exact text
     *
     * @private
     */
    retriveText() {
        let exactText;
        let currentElement;
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element instanceof ErrorTextElementBox) {
            currentElement = this.currentContextInfo.element;
            exactText = this.currentContextInfo.element.text;
            this.documentHelper.selection.start = currentElement.start.clone();
            this.documentHelper.selection.end = currentElement.end.clone();
        }
        else {
            const startPosition = this.documentHelper.selection.start;
            const offset = startPosition.offset;
            const startIndex = 0;
            const startInlineObj = startPosition.currentWidget.getInline(offset, startIndex);
            currentElement = startInlineObj.element;
            exactText = startInlineObj.element.text;
        }
        return { 'text': exactText, 'element': currentElement };
    }
    /**
     * Method to handle suggestions
     *
     * @private
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    handleSuggestions(allsuggestions) {
        this.spellCheckSuggestion = [];
        if (allsuggestions.length === 0) {
            this.spellCheckSuggestion.push(this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary'));
        }
        else {
            allsuggestions = (allsuggestions.length > 3) ? this.constructInlineMenu(allsuggestions) : allsuggestions;
            this.spellCheckSuggestion.push(this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary'));
        }
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const spellSuggestion = [];
        if (this.spellCheckSuggestion.length > 0) {
            for (const str of this.spellCheckSuggestion) {
                spellSuggestion.push({
                    text: str,
                    id: this.documentHelper.owner.element.id + '_contextmenu_otherSuggestions_spellcheck_' + (str === this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary') ? 'Add to Dictionary' : str),
                    iconCss: ''
                });
            }
        }
        return spellSuggestion;
    }
    /**
     * Method to check whether text element has errors
     *
     * @private
     */
    checktextElementHasErrors(text, element, left) {
        let hasError = false;
        const erroElements = [];
        text = text.replace(/[\s]+/g, '');
        if (!isNullOrUndefined(element.errorCollection) && element.errorCollection.length > 0) {
            if (!this.documentHelper.isScrollHandler && (element.isChangeDetected || element.paragraph.isChangeDetected) && !element.istextCombined) {
                this.updateStatusForGlobalErrors(element.errorCollection, element);
                element.errorCollection = [];
                element.isChangeDetected = true;
                return { 'errorFound': hasError, 'elements': erroElements };
            }
            for (let i = 0; i < element.errorCollection.length; i++) {
                if (this.handleErrorCollection(element.errorCollection[i])) {
                    hasError = true;
                    erroElements.push(element.errorCollection[i]);
                }
            }
        }
        else if (!this.documentHelper.isScrollHandler && element.paragraph.isChangeDetected) {
            element.isChangeDetected = true;
        }
        else if (!element.isChangeDetected) {
            if (this.handleErrorCollection(element)) {
                hasError = true;
                erroElements.push(element);
            }
            else if (!this.enableUserDictionary && !isNullOrUndefined(element.currentUser)) {
                // Set isChangeDetected to true since the enableUserDictionary property changed from true to false,
                // so we need to re-evaluate the word
                element.isChangeDetected = true;
                element.currentUser = undefined;
            }
            else if (this.enableUserDictionary && element.currentUser !== (this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser)) {
                // Set isChangeDetected to true since the enableUserDictionary property changed from false to true or the user is switched,
                // so we need to re-evaluate the word
                element.isChangeDetected = true;
                element.currentUser = this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser;
            }
        }
        // If the user-specific dictionary is enabled and the current user is not defined, set the current user
        if ((this.enableUserDictionary && isNullOrUndefined(element.currentUser))) {
            element.currentUser = this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser;
        }
        return { 'errorFound': hasError, 'elements': erroElements };
    }
    updateStatusForGlobalErrors(erroElements, parentElement) {
        if (erroElements.length > 0) {
            for (let i = 0; i < erroElements.length; i++) {
                const exactText = this.manageSpecialCharacters(erroElements[i].text, undefined, true);
                if (this.errorWordCollection.containsKey(exactText)) {
                    const elements = this.errorWordCollection.get(exactText);
                    for (let j = 0; j < elements.length; j++) {
                        if (elements[j] instanceof ErrorTextElementBox && elements[j] === erroElements[i]) {
                            elements[j].isChangeDetected = true;
                            elements[j].start.offset = parentElement.line.getOffset(parentElement.istextCombined ? this.getCombinedElement(parentElement) : parentElement, 0);
                            elements[j].line = parentElement.line;
                            break;
                        }
                    }
                }
            }
        }
    }
    /**
     * Method to handle document error collection.
     *
     * @param {string} errorInElement
     * @private
     */
    handleErrorCollection(errorInElement) {
        const errors = this.errorWordCollection;
        const exactText = this.manageSpecialCharacters(errorInElement.text, undefined, true);
        if (errors.containsKey(exactText) && errorInElement.length > 1) {
            const ignoreAllIndex = this.ignoreAllItems.indexOf(exactText);
            if (ignoreAllIndex > -1) {
                if (errors.containsKey(exactText)) {
                    errors.remove(exactText);
                }
                return false;
            }
            return true;
        }
        return false;
    }
    /* eslint-disable @typescript-eslint/no-explicit-any */
    constructInlineMenu(inlineSuggestion) {
        for (let i = inlineSuggestion.length - 1; i > 0; i--) {
            if (inlineSuggestion.length > 3) {
                this.spellCheckSuggestion.push(inlineSuggestion[i]);
                inlineSuggestion.pop();
            }
        }
        return inlineSuggestion;
    }
    /**
     * Method to retrieve error element text
     *
     * @private
     */
    findCurretText() {
        const insertPosition = this.documentHelper.selection.start;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        let element;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        let inlineObj = insertPosition.currentWidget.getInline(this.documentHelper.selection.start.offset, 0);
        let text;
        // If selection is in header/footer prefer header/footer error element
        if (!isNullOrUndefined(insertPosition.currentWidget) && insertPosition.currentWidget.paragraph && insertPosition.currentWidget.paragraph.isInHeaderFooter) {
            const errorWords = this.errorWordCollection;
            const currentWord = this.getErrorWordText(inlineObj.element.text);
            const exactKey = this.manageSpecialCharacters(currentWord, undefined, true);
            if (errorWords.length > 0) {
                const errorElements = errorWords.get(exactKey);
                if (!isNullOrUndefined(errorElements)) {
                    for (let elementIndex = 0; elementIndex < errorElements.length; elementIndex++) {
                        const collectionElement = errorElements[elementIndex];
                        if (collectionElement instanceof ErrorTextElementBox) {
                            if (!isNullOrUndefined(collectionElement.start.paragraph) && collectionElement.start.paragraph.isInHeaderFooter) {
                                if (collectionElement.start && collectionElement.end && collectionElement.start.offset <= insertPosition.offset && collectionElement.end.offset >= insertPosition.offset) {
                                    return { 'text': collectionElement.text, 'element': collectionElement };
                                }
                            }
                        }
                        else if (collectionElement instanceof TextElementBox) {
                            if (collectionElement.line && collectionElement.line.paragraph && collectionElement.line.paragraph.isInHeaderFooter) {
                                const matchResults = this.getMatchedResultsFromElement(collectionElement);
                                const results = matchResults.textResults;
                                const markIndex = (collectionElement.isChangeDetected && !isNullOrUndefined(collectionElement.start)) ? collectionElement.start.offset : collectionElement.line.getOffset(collectionElement, 0);
                                this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, collectionElement, false, null, markIndex);
                                for (let resultIndex = 0; resultIndex < results.length; resultIndex++) {
                                    const errorElement = this.createErrorElementWithInfo(results.innerList[resultIndex], collectionElement);
                                    if (errorElement.start && errorElement.end && errorElement.start.paragraph.isInHeaderFooter) {
                                        if (errorElement.start.offset <= insertPosition.offset && errorElement.end.offset >= insertPosition.offset) {
                                            return { 'text': errorElement.text, 'element': errorElement };
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (!isNullOrUndefined(inlineObj.element)) {
            if (!isNullOrUndefined(inlineObj.element.errorCollection) && inlineObj.element.errorCollection.length > 0) {
                for (let i = 0; i < inlineObj.element.errorCollection.length; i++) {
                    const errorElement = inlineObj.element.errorCollection[i];
                    // If the cursor is in error element, then we need to retrieve the text from that error element.
                    if (errorElement.start.isExistBefore(this.documentHelper.selection.start) && errorElement.end.isExistAfter(this.documentHelper.selection.start)) {
                        text = errorElement.text;
                        element = errorElement;
                        break;
                    }
                }
            }
            else {
                text = inlineObj.element.text;
                element = inlineObj.element;
            }
            if (text === ' ') {
                inlineObj = insertPosition.currentWidget.getInline(this.documentHelper.selection.start.offset + 1, 0);
                text = inlineObj.element.text;
            }
        }
        return { 'text': text, 'element': element };
    }
    addErrorCollection(text, elementToCompare, suggestions) {
        text = this.manageSpecialCharacters(text, undefined, true);
        if (this.errorWordCollection.containsKey(text)) {
            const errorElements = this.errorWordCollection.get(text);
            if (elementToCompare instanceof ErrorTextElementBox) {
                if (!this.compareErrorTextElement(elementToCompare, errorElements)) {
                    errorElements.push(elementToCompare);
                }
            }
            else if (elementToCompare instanceof TextElementBox) {
                if (!this.compareTextElement(elementToCompare, errorElements)) {
                    errorElements.push(elementToCompare);
                }
            }
        }
        else {
            if (!isNullOrUndefined(suggestions) && suggestions.length > 0) {
                this.errorSuggestions.add(text, suggestions);
            }
            this.errorWordCollection.add(text, [elementToCompare]);
            if (!this.uniqueWordsCollection.containsKey(text)) {
                this.uniqueWordsCollection.add(text, true);
            }
        }
    }
    /**
     * Updates the error collection when a new error element is created.
     * If an existing error element with matching offsets is found, it is replaced.
     */
    updateErrorCollection(text, elementToCompare) {
        let isChanged = false;
        if (this.errorWordCollection.containsKey(text)) {
            const errorElements = this.errorWordCollection.get(text);
            if (elementToCompare instanceof ErrorTextElementBox && errorElements.length > 0) {
                for (let i = 0; i < errorElements.length; i++) {
                    const currentElement = errorElements[i];
                    if (currentElement instanceof ErrorTextElementBox) {
                        if (elementToCompare.start.offset === currentElement.start.offset &&
                            elementToCompare.end.offset === currentElement.end.offset) {
                            this.removeErrorsFromCollection({ 'element': errorElements[i], 'text': text });
                            isChanged = true;
                        }
                    }
                }
                if (isChanged) {
                    errorElements.push(elementToCompare);
                }
            }
        }
    }
    /**
     * Method to retrieve error text if text is not matched with error word collection
     *
     * @private
     */
    getErrorWordText(text) {
        const start = this.documentHelper.selection.start.clone();
        const end = this.documentHelper.selection.end.clone();
        this.documentHelper.selection.isModifyingSelectionInternally = true;
        this.documentHelper.selection.selectCurrentWord();
        let currentWord = this.documentHelper.selection.text;
        let exactData = this.manageSpecialCharacters(currentWord, undefined, true);
        if (!isNullOrUndefined(exactData) && this.errorWordCollection.containsKey(exactData)) {
            currentWord = exactData;
        }
        else {
            currentWord = text;
        }
        this.documentHelper.selection.selectRange(start, end);
        this.documentHelper.selection.isModifyingSelectionInternally = false;
        return currentWord;
    }
    addCorrectWordCollection(text) {
        text = this.manageSpecialCharacters(text, undefined, true);
        if (!this.uniqueWordsCollection.containsKey(text)) {
            this.uniqueWordsCollection.add(text, false);
        }
    }
    /**
     * @private
     */
    isInUniqueWords(text) {
        text = text.replace(/[\s]+/g, '');
        return this.uniqueWordsCollection.containsKey(text);
    }
    /**
     * @private
     */
    isErrorWord(text) {
        text = text.replace(/[\s]+/g, '');
        return this.uniqueWordsCollection.get(text);
    }
    /**
     * @private
     */
    isCorrectWord(text) {
        text = text.replace(/[\s]+/g, '');
        return !this.uniqueWordsCollection.get(text);
    }
    compareErrorTextElement(errorElement, errorCollection) {
        const copyElement = [];
        let isChanged = false;
        for (let i = 0; i < errorCollection.length; i++) {
            copyElement.push(errorCollection[i]);
        }
        const length = errorCollection.length;
        for (let i = 0; i < length; i++) {
            if (copyElement[i] instanceof ErrorTextElementBox) {
                if (copyElement[i].isChangeDetected) {
                    const exactText = this.manageSpecialCharacters(copyElement[i].text, undefined, true);
                    isChanged = true;
                    this.removeErrorsFromCollection({ 'element': copyElement[i], 'text': exactText });
                }
                else {
                    const currentElement = copyElement[i];
                    if (errorElement.start.offset === currentElement.start.offset && errorElement.end.offset === currentElement.end.offset && currentElement === errorElement) {
                        return true;
                    }
                }
            }
        }
        if (isChanged) {
            this.errorWordCollection.add(this.manageSpecialCharacters(errorElement.text, undefined, true), [errorElement]);
        }
        return false;
    }
    /**
     * Method to compare text elements
     *
     * @private
     */
    compareTextElement(errorElement, errorCollection) {
        for (let i = 0; i < errorCollection.length; i++) {
            if (errorCollection[i] instanceof TextElementBox) {
                const currentElement = errorCollection[i];
                if (currentElement === errorElement) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Method to handle Word by word spell check
     *
     * @private
     */
    handleWordByWordSpellCheck(jsonObject, elementBox, left, top, underlineY, baselineAlignment, isSamePage, currentText) {
        if (isNullOrUndefined(currentText)) {
            currentText = elementBox.text;
        }
        if (jsonObject.HasSpellingError && isSamePage) {
            this.addErrorCollection(currentText, elementBox, jsonObject.Suggestions);
            if (currentText.trim() === elementBox.text.trim()) {
                const backgroundColor = (elementBox.line.paragraph.containerWidget instanceof TableCellWidget) ? elementBox.line.paragraph.containerWidget.cellFormat.shading.backgroundColor : this.documentHelper.backgroundColor;
                this.documentHelper.render.renderWavyLine(elementBox, left, top, underlineY, '#FF0000', 'Single', baselineAlignment, backgroundColor);
                elementBox.isSpellChecked = true;
            }
        }
        else {
            this.addCorrectWordCollection(currentText);
            elementBox.isSpellChecked = true;
        }
    }
    /**
     * Method to check errors for combined elements
     *
     * @private
     */
    checkElementCanBeCombined(elementBox, underlineY, beforeIndex, callSpellChecker, textToCombine, isNext, isPrevious, canCombine) {
        let currentText = isNullOrUndefined(textToCombine) ? '' : textToCombine;
        let isCombined = isNullOrUndefined(canCombine) ? false : canCombine;
        const checkPrevious = !isNullOrUndefined(isPrevious) ? isPrevious : true;
        const checkNext = !isNullOrUndefined(isNext) ? isNext : true;
        const line = this.documentHelper.selection.getLineWidget(elementBox, 0);
        const index = line.children.indexOf(elementBox);
        let prevText = elementBox.text;
        if (this.combinedElements.indexOf(elementBox) === -1) {
            elementBox.isChangeDetected = false;
            this.combinedElements.push(elementBox);
        }
        const difference = (isPrevious) ? 0 : 1;
        let prevCombined = false;
        let isPrevField = false;
        const forbiddenChars = /[#@!$%^&*()\-_\+=\{\}\[\]:;"”',<>\/?\s`’\\]/;
        const boundaryRegexStart = new RegExp(`^${forbiddenChars.source}+`);
        const boundaryRegexEnd = new RegExp(`${forbiddenChars.source}+$`);
        if (elementBox.text !== '\v') {
            if (checkPrevious) {
                let textElement = undefined;
                for (let i = index - difference; i >= 0; i--) {
                    textElement = line.children[i];
                    if (!isNullOrUndefined(textElement) && textElement.revisionLength > 0 && textElement.getRevision(0).revisionType === "Deletion") {
                        break;
                    }
                    const prevTextCheck = !boundaryRegexStart.test(prevText) && !boundaryRegexEnd.test(textElement.text);
                    if (textElement instanceof TextElementBox && !isPrevField && !(textElement instanceof FootnoteElementBox)) {
                        if (prevText.indexOf(' ') !== 0 && textElement.text.lastIndexOf(' ') !== textElement.text.length - 1 &&
                            prevText.indexOf('\t') !== 0 && textElement.text.lastIndexOf('\t') !== textElement.text.length - 1 &&
                            prevText.indexOf('[') !== 0 && textElement.text.lastIndexOf('[') !== textElement.text.length - 1 &&
                            prevText.indexOf(']') !== 0 && textElement.text.lastIndexOf(']') !== textElement.text.length - 1 &&
                            prevTextCheck) {
                            prevCombined = !isNullOrUndefined(textToCombine) ? true : false;
                            currentText = textElement.text + currentText;
                            prevText = textElement.text;
                            isPrevField = false;
                            if (this.combinedElements.indexOf(textElement) === -1) {
                                this.combinedElements.push(textElement);
                            }
                            isCombined = true;
                        }
                        else if (!isNullOrUndefined(textElement)) {
                            textElement = textElement.nextElement;
                            break;
                        }
                    }
                    else if (textElement instanceof FieldElementBox && textElement.fieldType !== 1) {
                        isPrevField = true;
                    }
                }
                const currentElement = (isCombined) ? textElement : elementBox;
                if (this.lookThroughPreviousLine(currentText, prevText, currentElement, underlineY, beforeIndex)) {
                    this.combinedElements.length = 0;
                    return true;
                }
            }
            if (!(elementBox instanceof FootnoteElementBox)) {
                if (isPrevious) {
                    currentText = (prevCombined) ? currentText : elementBox.text + currentText;
                }
                else {
                    currentText += elementBox.text;
                }
            }
            isPrevField = false;
            let nextText = elementBox.text;
            if (checkNext) {
                let canCombine = false;
                let element = undefined;
                for (let i = index + 1; i < line.children.length; i++) {
                    element = line.children[i];
                    if (!isNullOrUndefined(element) && element.revisionLength > 0 && element.getRevision(0).revisionType === "Deletion") {
                        break;
                    }
                    const nextTextCheck = !boundaryRegexEnd.test(nextText) && !boundaryRegexStart.test(element.text);
                    if (element instanceof TextElementBox && !isPrevField && !(element instanceof FootnoteElementBox)) {
                        if (nextText.lastIndexOf(' ') !== nextText.length - 1 && element.text.indexOf(' ') !== 0 &&
                            nextText.lastIndexOf('\t') !== nextText.length - 1 && element.text.indexOf('\t') !== 0 &&
                            nextText.lastIndexOf('[') !== nextText.length - 1 && element.text.indexOf('[') !== 0 &&
                            nextText.lastIndexOf(']') !== nextText.length - 1 && element.text.indexOf(']') !== 0 &&
                            nextTextCheck) {
                            currentText += element.text;
                            nextText = element.text;
                            isPrevField = false;
                            this.combinedElements.push(element);
                            canCombine = true;
                            isCombined = true;
                        }
                        else if (!isNullOrUndefined(element)) {
                            element = element.previousElement;
                            break;
                        }
                    }
                    else if (element instanceof FieldElementBox && element.fieldType !== 2) {
                        isPrevField = true;
                    }
                }
                const currentElement = (canCombine) ? element : elementBox;
                if (currentElement.text !== '\f' && currentElement.text !== String.fromCharCode(14) && this.lookThroughNextLine(currentText, prevText, currentElement, underlineY, beforeIndex)) {
                    this.combinedElements.length = 0;
                    return true;
                }
            }
        }
        if (isCombined && callSpellChecker && !this.checkCombinedElementsBeIgnored(this.combinedElements, currentText)) {
            if (isPrevious || isNext) {
                for (let i = 0; i < this.combinedElements.length; i++) {
                    this.combinedElements[i].isChangeDetected = false;
                    if (i !== 0) {
                        this.combinedElements[i].istextCombined = true;
                        this.combinedElements[i].errorCollection = this.combinedElements[0].errorCollection;
                    }
                }
            }
            else {
                for (let i = 0; i < this.combinedElements.length; i++) {
                    this.combinedElements[i].isChangeDetected = false;
                    if (i !== 0) {
                        this.combinedElements[i].istextCombined = true;
                        this.combinedElements[i].errorCollection = this.combinedElements[0].errorCollection;
                    }
                }
                this.combinedElements.length = 0;
            }
            this.handleCombinedElements(elementBox, currentText, underlineY);
        }
        this.combinedElements.length = 0;
        return isCombined;
    }
    lookThroughPreviousLine(currentText, prevText, currentElement, underlineY, beforeIndex) {
        if (!isNullOrUndefined(currentElement) && currentElement.indexInOwner === 0 && !isNullOrUndefined(currentElement.line.previousLine)) {
            const previousLine = currentElement.line.previousLine;
            const index = previousLine.children.length - 1;
            if (!isNullOrUndefined(previousLine.children[index]) && previousLine.children[index] instanceof TextElementBox) {
                const firstElement = previousLine.children[index];
                if (!isNullOrUndefined(currentElement.text)) {
                    if (currentElement.text.indexOf(' ') !== 0 && firstElement.text.lastIndexOf(' ') !== firstElement.text.length - 1 && !(firstElement.text === '\v' || firstElement.text === '\t' || firstElement.text === '\f')) {
                        currentText = (currentText.length > 0) ? currentText : prevText;
                        this.checkElementCanBeCombined(firstElement, underlineY, beforeIndex, true, currentText, false, true, true);
                        return true;
                    }
                }
            }
        }
        return false;
    }
    lookThroughNextLine(currentText, prevText, elementBox, underlineY, beforeIndex) {
        if (elementBox instanceof TextElementBox && !isNullOrUndefined(elementBox) && elementBox.indexInOwner === elementBox.line.children.length - 1 && !isNullOrUndefined(elementBox.line.nextLine)) {
            const nextLine = elementBox.line.nextLine;
            if (!isNullOrUndefined(nextLine.children[0]) && nextLine.children[0] instanceof TextElementBox) {
                const firstElement = nextLine.children[0];
                if (elementBox.text.lastIndexOf(' ') !== elementBox.text.length - 1 && firstElement.text.indexOf(' ') !== 0 && !(elementBox.text === '\v' || elementBox.text === '\t' || elementBox.text === '\f')) {
                    currentText = (currentText.length > 0) ? currentText : prevText;
                    this.checkElementCanBeCombined(firstElement, underlineY, beforeIndex, true, currentText, true, false, true);
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Method to handle combined elements
     *
     * @param {TextElementBox} elementBox
     * @param {string} currentText
     * @param {number} underlineY
     * @param {number} beforeIndex
     * @private
     */
    handleCombinedElements(elementBox, currentText, underlineY) {
        const splittedText = currentText.split(/[()\s{}\[\]]+/);
        if (this.ignoreAllItems.indexOf(currentText) === -1 && elementBox instanceof TextElementBox && elementBox.ignoreOnceItems.indexOf(currentText) === -1) {
            if (splittedText.length > 1) {
                for (let i = 0; i < splittedText.length; i++) {
                    let currentText = splittedText[i];
                    currentText = this.manageSpecialCharacters(currentText, undefined, true);
                    if (this.ignoreAllItems.indexOf(currentText) === -1 && elementBox instanceof TextElementBox && elementBox.ignoreOnceItems.indexOf(currentText) === -1) {
                        this.documentHelper.render.handleUnorderedElements(currentText, elementBox, underlineY, i, 0, i === splittedText.length - 1, this.combinedElements);
                    }
                }
            }
            else {
                currentText = this.manageSpecialCharacters(currentText, undefined, true);
                let text = currentText.split(/[()\s{}\[\]]+/);
                currentText = text[0];
                this.documentHelper.render.handleUnorderedElements(currentText, elementBox, underlineY, 0, 0, true, this.combinedElements);
            }
        }
    }
    /**
     * Method to check error element collection has unique element
     *
     * @param {ErrorTextElementBox[]} errorCollection
     * @param {ErrorTextElementBox} elementToCheck
     * @private
     */
    checkArrayHasSameElement(errorCollection, elementToCheck) {
        for (let i = 0; i < errorCollection.length; i++) {
            const errorText = errorCollection[i];
            if ((errorText.start.location.x === elementToCheck.start.location.x) && (errorText.start.location.y === elementToCheck.start.location.y)) {
                return true;
            }
        }
        return false;
    }
    /**
     * @private
     */
    handleSplitWordSpellCheck(jsonObject, currentText, elementBox, isSamePage, underlineY, iteration, markIndex, isLastItem, combinedElements) {
        if (jsonObject.HasSpellingError && elementBox.text !== ' ' && isSamePage) {
            const textSearch = this.documentHelper.owner.searchModule.textSearch;
            let matchResults = this.getMatchedResultsFromElement(elementBox, currentText);
            // Handled combined elements split to multiple lines when textResults is empty.
            // Only the first element will be rendered with wavy line. Other elements will be rendered in renderTextElementBox method in render Element.
            if (!isNullOrUndefined(combinedElements) && matchResults.textResults.length === 0 && combinedElements.length > 0) {
                const combinedElement = combinedElements[0];
                matchResults = this.getMatchedResultsFromElement(combinedElement, combinedElement.text);
                markIndex = combinedElement.line.getOffset(this.getCombinedElement(combinedElement), 0);
                textSearch.updateMatchedTextLocation(matchResults.matches, matchResults.textResults, matchResults.elementInfo, 0, combinedElement, false, null, markIndex);
                this.handleMatchedResults(matchResults.textResults, combinedElement, underlineY, iteration, jsonObject.Suggestions, false, currentText, combinedElements);
            }
            else {
                markIndex = (elementBox.istextCombined) ? elementBox.line.getOffset(this.getCombinedElement(elementBox), 0) : markIndex;
                textSearch.updateMatchedTextLocation(matchResults.matches, matchResults.textResults, matchResults.elementInfo, 0, elementBox, false, null, markIndex);
                this.handleMatchedResults(matchResults.textResults, elementBox, underlineY, iteration, jsonObject.Suggestions, isLastItem);
            }
        }
        else {
            this.addCorrectWordCollection(currentText);
            if (isLastItem) {
                elementBox.isSpellChecked = true;
            }
        }
        this.updateUniqueWord([{ Text: currentText, HasSpellError: jsonObject.HasSpellingError }]);
    }
    handleMatchedResults(results, elementBox, wavyLineY, index, suggestions, isLastItem, errorText, combinedElements) {
        if (results.length === 0 && isLastItem) {
            elementBox.isSpellChecked = true;
            return;
        }
        for (let i = 0; i < results.length; i++) {
            const span = this.createErrorElementWithInfo(results.innerList[i], elementBox);
            // Updated the error text and text position for combined elements.
            if (!isNullOrUndefined(errorText)) {
                span.text = errorText;
                const startElement = combinedElements[0];
                const endElement = combinedElements[combinedElements.length - 1];
                // Set the start and end position for the error element when text is splitted into multiple lines.
                if (startElement && endElement) {
                    let offset = startElement.line.getOffset(startElement, 0);
                    let startPosition = new TextPosition(this.documentHelper.owner);
                    startPosition.setPositionParagraph(startElement.line, offset);
                    offset = endElement.line.getOffset(endElement, (endElement.length));
                    let endPosition = new TextPosition(this.documentHelper.owner);
                    endPosition.setPositionParagraph(endElement.line, offset);
                    span.start = startPosition;
                    span.end = endPosition;
                }
            }
            const color = '#FF0000';
            if (!isNullOrUndefined(elementBox.errorCollection) && !this.checkArrayHasSameElement(elementBox.errorCollection, span)) {
                elementBox.errorCollection.splice(index, 0, span);
            }
            this.addErrorCollection(span.text, span, suggestions);
            const elements = this.errorWordCollection.get(span.text);
            if (!isNullOrUndefined(elements) && elements.indexOf(elementBox) !== -1 && elements.indexOf(elementBox) !== elements.indexOf(span)) {
                elements.splice(elements.indexOf(elementBox), 1);
            }
            const backgroundColor = (elementBox.line.paragraph.containerWidget instanceof TableCellWidget) ? elementBox.paragraph.containerWidget.cellFormat.shading.backgroundColor : this.documentHelper.backgroundColor;
            const para = elementBox.line.paragraph;
            let lineY = para.y;
            for (let i = 0; i < para.childWidgets.length; i++) {
                if (para.childWidgets[i] == elementBox.line)
                    break;
                lineY += para.childWidgets[i].height;
            }
            if (elementBox.isRightToLeft) {
                this.documentHelper.render.renderWavyLine(span, span.end.location.x, lineY, wavyLineY, color, 'Single', elementBox.characterFormat.baselineAlignment, backgroundColor);
            }
            else {
                this.documentHelper.render.renderWavyLine(span, span.start.location.x, lineY, wavyLineY, color, 'Single', elementBox.characterFormat.baselineAlignment, backgroundColor);
            }
            if (isLastItem) {
                elementBox.isSpellChecked = true;
            }
        }
    }
    /**
     * Calls the spell checker service.
     * @private
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    callSpellChecker(languageID, word, checkSpelling, checkSuggestion, addWord, isByPage) {
        const spellchecker = this;
        return new Promise((resolve, reject) => {
            if (!isNullOrUndefined(this)) {
                const httpRequest = new XMLHttpRequest();
                let service = this.documentHelper.owner.serviceUrl;
                service = (isByPage) ? service + this.documentHelper.owner.serverActionSettings.spellCheckByPage : service + this.documentHelper.owner.serverActionSettings.spellCheck;
                httpRequest.open('POST', service, true);
                httpRequest.setRequestHeader('Content-Type', 'application/json');
                let headers = this.documentHelper.owner.headers;
                /* eslint-disable @typescript-eslint/no-explicit-any */
                if (isByPage) {
                    word = word.replace(String.fromCharCode(160), ' ');
                }
                const spellCheckData = { LanguageID: languageID, TexttoCheck: word, CheckSpelling: checkSpelling, CheckSuggestion: checkSuggestion, AddWord: addWord, IgnoreUppercase: this.ignoreUppercase };
                if (this.enableUserDictionary) {
                    spellCheckData.UserName = this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser;
                }
                const httprequestEventArgs = { serverActionType: 'SpellCheck', headers: headers, timeout: 0, cancel: false, withCredentials: false };
                headers = httprequestEventArgs.headers;
                this.documentHelper.owner.trigger(beforeXmlHttpRequestSend, httprequestEventArgs);
                this.setCustomHeaders(httpRequest, httprequestEventArgs.headers);
                httpRequest.withCredentials = httprequestEventArgs.withCredentials;
                if (!httprequestEventArgs.cancel) {
                    httpRequest.send(JSON.stringify(spellCheckData));
                }
                httpRequest.onreadystatechange = () => {
                    if (httpRequest.readyState === 4) {
                        if (httpRequest.status === 200 || httpRequest.status === 304) {
                            resolve(httpRequest.response);
                        }
                        else {
                            const result = {
                                status: httpRequest.status.toString(),
                                statusText: httpRequest.responseText,
                                url: service
                            };
                            result.name = 'onFailure';
                            if (!isNullOrUndefined(spellchecker.documentHelper)) {
                                spellchecker.documentHelper.owner.fireServiceFailure(result);
                            }
                            reject(httpRequest.response);
                        }
                    }
                };
            }
        });
    }
    setCustomHeaders(httpRequest, headers) {
        if (!isNullOrUndefined(headers)) {
            for (let i = 0; i < headers.length; i++) {
                const header = headers[i];
                for (const key of Object.keys(header)) {
                    httpRequest.setRequestHeader(key, header[key]);
                }
            }
        }
    }
    checkForHeaderFooterNextError() {
        if (!isNullOrUndefined(this.viewer)) {
            const errorWords = this.errorWordCollection;
            let element;
            if (errorWords.length > 0) {
                for (let i = 0; i < errorWords.length; i++) {
                    const errorElements = errorWords.get(errorWords.keys[i]);
                    if (isNullOrUndefined(errorElements)) {
                        continue;
                    }
                    for (let j = 0; j < errorElements.length; j++) {
                        if (errorElements[j] instanceof ErrorTextElementBox && !errorElements[j].isChangeDetected) {
                            if ((isNullOrUndefined(errorElements[j].start.paragraph) || errorElements[j].start.paragraph.indexInOwner === -1)) {
                                errorElements.splice(j, 1);
                                j--;
                                if (errorElements.length === 0) {
                                    this.errorWordCollection.remove(errorWords.keys[i]);
                                    i--;
                                }
                            }
                            else {
                                if (isNullOrUndefined(element) && errorElements[j].start.paragraph.isInHeaderFooter) {
                                    return { element: errorElements[j], text: errorWords.keys[i] };
                                }
                            }
                        }
                        else if (errorElements[j] instanceof TextElementBox) {
                            if (isNullOrUndefined(errorElements[j].paragraph) || errorElements[j].paragraph.indexInOwner === -1) {
                                errorElements.splice(j, 1);
                                j--;
                                if (errorElements.length === 0) {
                                    this.errorWordCollection.remove(errorWords.keys[i]);
                                    i--;
                                }
                            }
                            else {
                                if (isNullOrUndefined(element) && errorElements[j].line && errorElements[j].line.paragraph && errorElements[j].line.paragraph.isInHeaderFooter) {
                                    const matchResults = this.getMatchedResultsFromElement(errorElements[j]);
                                    const results = matchResults.textResults;
                                    const markIndex = (errorElements[j].isChangeDetected && !isNullOrUndefined(errorElements[j].start)) ? errorElements[j].start.offset : errorElements[j].line.getOffset(errorElements[j], 0);
                                    this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, errorElements[j], false, null, markIndex);
                                    for (let i = 0; i < results.length; i++) {
                                        const errorElement = this.createErrorElementWithInfo(results.innerList[i], errorElements[j]);
                                        element = { element: errorElement, text: errorElement.text };
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                this.documentHelper.clearSelectionHighlight();
            }
            return element;
        }
        return undefined;
    }
    /**
     * Method to check for next error
     *
     * @private
     * @returns {void}
     */
    checkForNextError() {
        if (!isNullOrUndefined(this.viewer)) {
            if (this.errorWordCollection.length > 0) {
                let start = this.documentHelper.selection.start;
                const isInHeaderFooter = start.currentWidget.paragraph.isInHeaderFooter;
                let element;
                if (isInHeaderFooter) {
                    element = this.checkForHeaderFooterNextError();
                }
                if (!isInHeaderFooter) {
                    element = this.checkSelectionNextError(start);
                }
                if (isNullOrUndefined(element)) {
                    start = this.documentHelper.selection.getDocumentStart();
                    element = this.checkSelectionNextError(start);
                    if (!isNullOrUndefined(element) && !start.currentWidget.paragraph.isInHeaderFooter && this.documentHelper.owner.enableHeaderAndFooter) {
                        this.documentHelper.selection.closeHeaderFooter();
                    }
                }
                if (isNullOrUndefined(element)) {
                    element = this.checkForHeaderFooterNextError();
                }
                if (!isNullOrUndefined(element)) {
                    if (element.element instanceof ErrorTextElementBox) {
                        this.updateErrorElementTextBox(element.text, element.element);
                    }
                    else if (element.element instanceof TextElementBox) {
                        let errorElement = element.element;
                        const currentText = element.element.text.trim();
                        const matchResults = this.getMatchedResultsFromElement(errorElement, currentText);
                        const results = matchResults.textResults;
                        const markIndex = errorElement.line.getOffset(errorElement, 0);
                        this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, errorElement, false, null, markIndex);
                        for (let i = 0; i < results.length; i++) {
                            const errorTextElement = this.createErrorElementWithInfo(results.innerList[i], errorElement);
                            this.updateErrorElementTextBox(element.text, errorTextElement);
                            this.updateErrorCollection(element.text, errorTextElement);
                            break;
                        }
                    }
                }
            }
            else {
                this.documentHelper.clearSelectionHighlight();
            }
        }
    }
    checkSelectionNextError(start) {
        const errorWords = this.errorWordCollection;
        let element;
        let nextErrorPosition;
        for (let i = 0; i < errorWords.length; i++) {
            const errorElements = errorWords.get(errorWords.keys[i]);
            if (isNullOrUndefined(errorElements)) {
                continue;
            }
            for (let j = 0; j < errorElements.length; j++) {
                let errorElement = errorElements[j];
                let elementStart;
                if (errorElement instanceof ErrorTextElementBox || errorElement instanceof TextElementBox) {
                    if (errorElement instanceof ErrorTextElementBox) {
                        elementStart = errorElement.start;
                        if ((isNullOrUndefined(errorElement.start.paragraph) || errorElement.start.paragraph.indexInOwner === -1)) {
                            errorElements.splice(j, 1);
                            j--;
                            if (errorElements.length === 0) {
                                this.errorWordCollection.remove(errorWords.keys[i]);
                                i--;
                            }
                            continue;
                        }
                        if (errorElement.start.paragraph.isInHeaderFooter) {
                            continue;
                        }
                    }
                    else {
                        if (isNullOrUndefined(errorElement.paragraph) || errorElement.paragraph.indexInOwner === -1) {
                            errorElements.splice(j, 1);
                            j--;
                            if (errorElements.length === 0) {
                                this.errorWordCollection.remove(errorWords.keys[i]);
                                i--;
                            }
                            continue;
                        }
                        if (errorElement.paragraph.isInHeaderFooter) {
                            continue;
                        }
                    }
                    if (isNullOrUndefined(elementStart)) {
                        let offset = errorElement.line.getOffset(errorElement, 1);
                        elementStart = new TextPosition(this.documentHelper.owner);
                        elementStart.setPositionParagraph(errorElement.line, offset);
                    }
                    if (elementStart) {
                        const isExistBefore = start.isExistBefore(elementStart);
                        if (isNullOrUndefined(nextErrorPosition)) {
                            if (isExistBefore) {
                                element = { element: errorElement, text: errorWords.keys[i] };
                                nextErrorPosition = elementStart;
                            }
                        }
                        else {
                            const isExistAfter = nextErrorPosition.isExistAfter(elementStart);
                            if (isExistBefore && isExistAfter) {
                                element = { element: errorElement, text: errorWords.keys[i] };
                                nextErrorPosition = elementStart;
                            }
                        }
                    }
                }
            }
        }
        return element;
    }
    /**
     * Method to create error element with matched results
     *
     * @param {TextSearchResult} result
     * @param {ElementBox} errorElement
     * @private
     */
    createErrorElementWithInfo(result, errorElement) {
        const element = new ErrorTextElementBox();
        let isUpdated = false;
        const text = this.documentHelper.selection.getTextInternal(result.start, result.end, false);
        if (errorElement instanceof ErrorTextElementBox && (isNullOrUndefined(result.start) || isNullOrUndefined(result.end) || isNullOrUndefined(text))) {
            element.text = errorElement.text;
            let line = errorElement.line;
            for (let i = 0; i < line.children.length; i++) {
                if (line.children[i] instanceof TextElementBox) {
                    let text = line.children[i].text;
                    let exactText = errorElement.text;
                    if (text.indexOf(exactText) !== -1) {
                        errorElement.start.offset = text.indexOf(exactText);
                        errorElement.end.offset = errorElement.start.offset + exactText.length;
                        element.start = errorElement.start;
                        element.end = errorElement.end;
                        element.start.currentWidget = errorElement.line;
                        element.end.currentWidget = errorElement.line;
                        isUpdated = true;
                        break;
                    }
                }
            }
            if (!isUpdated) {
                element.text = errorElement.text;
                element.start = errorElement.start;
                element.end = errorElement.end;
                isUpdated = true;
            }
        }
        if (!isUpdated) {
            element.text = text;
            element.start = result.start;
            element.end = result.end;
        }
        element.height = errorElement.height;
        element.canTrigger = errorElement.canTrigger;
        element.characterFormat.copyFormat(errorElement.characterFormat);
        // element.width = this.documentHelper.textHelper.getWidth(element.text, errorElement.characterFormat, (errorElement as TextElementBox).scriptType);
        element.width = Math.abs(element.start.location.x - element.end.location.x);
        return element;
    }
    /**
     * Method to get matched results from element box
     *
     * @private
     * @param {ElementBox} errorElement - Specifies the error element box.
     * @param {string} currentText - Specifies the current text
     * @returns {MatchResults} - Returns match results info.
     */
    getMatchedResultsFromElement(errorElement, currentText) {
        const line = errorElement.line;
        const searchText = (isNullOrUndefined(currentText)) ? errorElement.text : currentText;
        const pattern = this.documentHelper.owner.searchModule.textSearch.stringToRegex(searchText, 'CaseSensitive');
        this.textSearchResults.clearResults();
        const results = this.textSearchResults;
        const textLineInfo = this.documentHelper.owner.searchModule.textSearch.getElementInfo(line.children[0], 0, false, pattern, undefined, undefined, undefined, undefined, true);
        const text = textLineInfo.fullText;
        const matches = [];
        const spans = textLineInfo.elementsWithOffset;
        let matchObject;
        // Guard: skip matching if the search text is empty to prevent infinite loop
        if (isNullOrUndefined(searchText) || searchText.length === 0) {
            return { 'matches': matches, 'elementInfo': spans, 'textResults': results };
        }
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchObject = pattern.exec(text))) {
            // Prevent infinite loop on zero-length matches by manually advancing lastIndex
            if (matchObject[0].length === 0) {
                pattern.lastIndex++;
                continue;
            }
            const hasWhitespace = /\s/.test(errorElement.text);
            if (this.isChangeAll && !(errorElement instanceof ErrorTextElementBox) && !hasWhitespace) {
                matchObject.index = spans.get(errorElement);
            }
            matches.push(matchObject);
        }
        return { 'matches': matches, 'elementInfo': spans, 'textResults': results };
    }
    /**
     * Method to update error element information
     *
     * @private
     * @param {string} error - Specifies the error word.
     * @param {ErrorTextElementBox} errorElement - Specifies the error element box.
     * @returns {void}
     */
    updateErrorElementTextBox(error, errorElement) {
        const element = errorElement;
        this.documentHelper.clearSelectionHighlight();
        this.documentHelper.selection.start = element.start.clone();
        this.documentHelper.selection.end = element.end.clone();
        this.documentHelper.selection.highlight(errorElement.start.paragraph, errorElement.start, errorElement.end);
        this.documentHelper.owner.spellCheckDialogModule.updateSuggestionDialog(error, element);
    }
    /**
     * Method to retrieve space information in a text
     *
     * @private
     * @param {string} text - Specifies the text
     * @param {WCharacterFormat} characterFormat - Specifies the character format.
     * @returns {SpecialCharacterInfo} - Returs special character info.
     */
    getWhiteSpaceCharacterInfo(elementBox) {
        let text = elementBox.text;
        let characterFormat = elementBox.characterFormat;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        let matchedText = [];
        let width = 0;
        let length = 0;
        matchedText = text.match(/[\s]+/);
        if (!isNullOrUndefined(matchedText) && matchedText.length > 0) {
            for (let i = 0; i < matchedText.length; i++) {
                width += this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
                length += matchedText[i].length;
            }
        }
        return { 'width': width, 'wordLength': length, 'isBeginning': (!isNullOrUndefined(matchedText) && matchedText.index === 0) };
    }
    /**
     * Retrieve Special character info
     *
     * @private
     * @param {string} text - Specifies the text
     * @param {WCharacterFormat} characterFormat - Specifies the character format.
     * @returns {SpecialCharacterInfo} - Returs special character info.
     */
    getSpecialCharactersInfo(elementBox) {
        let text = elementBox.text;
        let characterFormat = elementBox.characterFormat;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        let matchedText = [];
        let beginingwidth = 0;
        let endWidth = 0;
        let length = 0;
        matchedText = text.match(/^[\#\@\!\~\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\:\;\"\'\,\<\.\>\/\?\`]*/);
        for (let i = 0; i < matchedText.length; i++) {
            if (!isNullOrUndefined(matchedText[i]) && matchedText[i].length > 0) {
                beginingwidth = this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
            }
            length = matchedText.length;
        }
        matchedText = text.match(/[\#\@\!\~\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\:\;\"\'\,\<\.\>\/\?\`]*$/);
        for (let i = 0; i < matchedText.length; i++) {
            if (!isNullOrUndefined(matchedText[i]) && matchedText[i].length > 0) {
                endWidth = this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
            }
            length = matchedText.length;
        }
        return { 'beginningWidth': beginingwidth, 'endWidth': endWidth, 'wordLength': length };
    }
    /**
     * Method to retrieve next available combined element
     *
     * @private
     * @param {ElementBox} element - Specified the element.
     * @returns {ElementBox} - Returns combined element.
     */
    getCombinedElement(element) {
        let prevElement = element;
        while (!isNullOrUndefined(element) && element instanceof TextElementBox && element.istextCombined) {
            prevElement = element;
            element = element.previousElement;
        }
        return prevElement;
    }
    checkCombinedElementsBeIgnored(elements, exactText) {
        exactText = this.manageSpecialCharacters(exactText, undefined, true);
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].ignoreOnceItems.indexOf(exactText) !== -1) {
                return true;
            }
        }
        return false;
    }
    /**
     * Method to update error collection
     *
     * @private
     * @param {TextElementBox} currentElement - Specifies current element.
     * @param {TextElementBox} splittedElement - Specifies splitted element.
     * @returns {void}
     */
    updateSplittedElementError(currentElement, splittedElement) {
        const errorCount = currentElement.errorCollection.length;
        if (errorCount > 0) {
            const errorCollection = [];
            for (let i = 0; i < errorCount; i++) {
                errorCollection.push(currentElement.errorCollection[i]);
            }
            for (let i = 0; i < errorCount; i++) {
                if (currentElement.text.indexOf(errorCollection[i].text) === -1) {
                    const index = currentElement.errorCollection.indexOf(errorCollection[i]);
                    splittedElement.isChangeDetected = true;
                    if (splittedElement.text.indexOf(errorCollection[i].text) !== -1) {
                        splittedElement.errorCollection.push(errorCollection[i]);
                    }
                    currentElement.errorCollection.splice(index, 1);
                }
            }
        }
    }
    /**
     * Method to update error collection
     *
     * @private
     * @param {TextElementBox} currentElement - Specifies current element.
     * @param {TextElementBox} splittedElement - Specifies splitted element.
     * @returns {void}
     */
    updateErrorCollectionForSplitElement(currentElement, splittedElement, splittedstartIndex) {
        const errorCount = (currentElement && currentElement.errorCollection) ? currentElement.errorCollection.length : 0;
        if (errorCount > 0) {
            const errorCollection = [];
            const splittedEndIndex = splittedstartIndex + (splittedElement.text.length);
            const currentElementIndex = currentElement.line.getOffset(currentElement, 0);
            for (let i = 0; i < errorCount; i++) {
                errorCollection.push(currentElement.errorCollection[i]);
            }
            for (let i = 0; i < errorCount; i++) {
                if (splittedElement && splittedElement.text.indexOf(errorCollection[i].text) !== -1 &&
                    errorCollection[i].start.offset >= currentElementIndex + splittedstartIndex && errorCollection[i].end.offset <= currentElementIndex + splittedEndIndex) {
                    splittedElement.errorCollection.push(errorCollection[i]);
                    let position = currentElement.errorCollection.indexOf(errorCollection[i]);
                    if (position >= 0) {
                        currentElement.errorCollection.splice(position, 1);
                    }
                }
            }
        }
    }
    /**
     * @private
     * @param {Page} page - Specifies the page.
     * @returns {string} - Returns page content.
     */
    getPageContent(page) {
        let content = '';
        if (this.documentHelper.owner.sfdtExportModule) {
            const sfdtExport = this.documentHelper.owner.sfdtExportModule;
            let index = sfdtExport.keywordIndex;
            sfdtExport.keywordIndex = 0;
            sfdtExport.Initialize();
            const document = sfdtExport.writePage(page, true);
            sfdtExport.keywordIndex = index;
            sfdtExport.blocks = [];
            if (this.documentHelper.owner.textExportModule) {
                const textExport = this.documentHelper.owner.textExportModule;
                textExport.pageContent = '';
                textExport.setDocument(document);
                textExport.writeInternal();
                content = textExport.pageContent;
            }
        }
        return content;
    }
    /**
     * @private
     * @param {any[]} spelledWords - Specifies spelledWords
     * @returns {void}
     */
    updateUniqueWords(spelledWords) {
        this.getUniqueWordsFromLocalStorage();
        const totalCount = spelledWords.length + this.uniqueSpelledWordsCount;
        if (totalCount <= this.uniqueWordsCount) {
            for (let i = 0; i < spelledWords.length; i++) {
                this.checkForUniqueWords(spelledWords[i]);
            }
        }
        this.addUniqueWordsToLocalStorage();
    }
    updateUniqueWord(spelledWords) {
        this.uniqueSpelledWords = this.uniqueSpelledWords || {};
        const totalCount = spelledWords.length + this.uniqueSpelledWordsCount;
        if (totalCount <= this.uniqueWordsCount) {
            for (let i = 0; i < spelledWords.length; i++) {
                this.checkForUniqueWords(spelledWords[i]);
            }
        }
    }
    /**
     * @private
     * Get the item from local storage and assign it to uniqueSpelledWords.
     * @returns {void}
     */
    getUniqueWordsFromLocalStorage() {
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            let spellData = JSON.parse(localStorage.getItem(this.uniqueKey));
            if (Object.keys(this.uniqueSpelledWords).length > 0 && Object.keys(spellData).length === 0) {
                spellData = this.uniqueSpelledWords;
            }
            this.uniqueSpelledWords = spellData;
        }
        this.uniqueSpelledWords = this.uniqueSpelledWords || {};
        this.uniqueSpelledWordsCount = Object.keys(this.uniqueSpelledWords).length;
    }
    /**
     * @private
     * set the uniqueSpelledWords to local storage.
     * @returns {void}
     */
    addUniqueWordsToLocalStorage() {
        try {
            localStorage.setItem(this.uniqueKey, JSON.stringify(this.uniqueSpelledWords));
        }
        catch (e) {
            if (e.name === 'QuotaExceededError') {
                this.clearCache();
                localStorage.setItem(this.uniqueKey, JSON.stringify(this.uniqueSpelledWords));
            }
        }
        this.uniqueSpelledWords = {};
        this.uniqueSpelledWordsCount = 0;
    }
    checkForUniqueWords(spellData) {
        const identityMatched = this.uniqueSpelledWords[spellData.Text];
        if (!identityMatched) {
            this.uniqueSpelledWords[spellData.Text] = spellData.HasSpellError;
            this.uniqueSpelledWordsCount++;
        }
    }
    /**
     * Method to clear cached words for spell check
     *
     * @returns {void}
     */
    clearCache() {
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
    }
    createGuid() {
        let dateTime = new Date().getTime();
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
            const randNo = (dateTime + Math.random() * 16) % 16 | 0;
            dateTime = Math.floor(dateTime / 16);
            return (char === 'x' ? randNo : (randNo & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
    /**
     * Check spelling in page data
     *
     * @private
     * @param {string} wordToCheck - Specifies wordToCheck
     * @param {TextElementBox} elementBox - Specifies elementBox
     * @returns {WordSpellInfo} - Retruns WordSpellInfo
     */
    checkSpellingInPageInfo(wordToCheck, elementBox) {
        const hasError = false;
        const elementPresent = false;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const uniqueWords = this.uniqueSpelledWords || {};
        if (!isNullOrUndefined(uniqueWords)) {
            if (!isNullOrUndefined(uniqueWords[wordToCheck])) {
                return { hasSpellError: uniqueWords[wordToCheck], isElementPresent: true };
            }
        }
        if (elementBox && isNullOrUndefined(uniqueWords[wordToCheck]) && elementBox.width === 0 && elementBox.height === 0) {
            return { hasSpellError: hasError, isElementPresent: true };
        }
        return { hasSpellError: hasError, isElementPresent: elementPresent };
    }
    /**
     * @private
     * @returns {void}
     */
    resetSpellCheckState() {
        this.documentHelper.cachedPages = [];
        if (!isNullOrUndefined(this.errorWordCollection)) {
            this.errorWordCollection.clear();
        }
        if (!isNullOrUndefined(this.uniqueWordsCollection)) {
            this.uniqueWordsCollection.clear();
        }
        this.ignoreAllItems = [];
        this.uniqueSpelledWords = {};
        this.errorSuggestions = new Dictionary();
        this.handleErrorElements = [];
        this.pageCacheIndex = [];
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
    }
    /**
     *
     * @private
     */
    triggerErrorForNonRenderPages() {
        if (this.documentHelper.render) {
            setTimeout(() => {
                for (let i = 0; i < this.documentHelper.pages.length; i++) {
                    let page = this.documentHelper.pages[i];
                    if (this.pageCacheIndex.indexOf(page.index) === -1) {
                        if (this.documentHelper.cachedPages.indexOf(page.index) === -1) {
                            this.documentHelper.cachedPages.push(page.index);
                        }
                        this.pageCacheIndex.push(page.index);
                        let content = this.getPageContent(page);
                        if (content.trim().length > 0) {
                            this.updateUniqueWords(HelperMethods.getSpellCheckData(content));
                            /* eslint-disable @typescript-eslint/no-explicit-any */
                            this.callSpellChecker(this.languageID, content, true, false, false, true).then((data) => {
                                /* eslint-disable @typescript-eslint/no-explicit-any */
                                let jsonObject = JSON.parse(data);
                                if (!isNullOrUndefined(this.documentHelper.owner)) {
                                    this.updateUniqueWords(jsonObject.SpellCollection);
                                    if (!isNullOrUndefined(this.documentHelper)) {
                                        this.documentHelper.triggerElementsOnLoading = true;
                                        this.documentHelper.triggerSpellCheck = true;
                                        this.documentHelper.triggerElementsOnLoading = true;
                                        this.documentHelper.render.skipRenderWavyLine = true;
                                        this.triggerPage(page);
                                        this.documentHelper.render.skipRenderWavyLine = false;
                                        this.documentHelper.triggerSpellCheck = false;
                                        this.documentHelper.triggerElementsOnLoading = false;
                                    }
                                }
                            })
                                .catch();
                            {
                                if (!isNullOrUndefined(this.documentHelper.render)) {
                                    this.documentHelper.render.skipRenderWavyLine = false;
                                }
                            }
                        }
                    }
                }
            }, 0);
        }
    }
    triggerPage(page) {
        this.getUniqueWordsFromLocalStorage();
        this.triggerWidgets(page);
        this.addUniqueWordsToLocalStorage();
    }
    triggerParagraphWidget(paragarph) {
        for (let i = 0; i < paragarph.childWidgets.length; i++) {
            let lineWidget = paragarph.childWidgets[i];
            for (let j = 0; j < lineWidget.children.length; j++) {
                if (lineWidget.children[j] instanceof TextElementBox && lineWidget.children[j].width !== 0 && lineWidget.children[j].height !== 0) {
                    this.documentHelper.render.triggerSpellChecker(lineWidget.children[j], undefined, false, 0, 0, 0, undefined);
                }
            }
        }
    }
    triggerTableWidget(table) {
        for (let i = 0; i < table.childWidgets.length; i++) {
            let rowWidget = table.childWidgets[i];
            for (let j = 0; j < rowWidget.childWidgets.length; j++) {
                let cellWidget = rowWidget.childWidgets[j];
                for (let k = 0; k < cellWidget.childWidgets.length; k++) {
                    if (cellWidget.childWidgets[k] instanceof TableWidget) {
                        this.triggerTableWidget(cellWidget.childWidgets[k]);
                    }
                    else if (cellWidget.childWidgets[k] instanceof ParagraphWidget) {
                        this.triggerParagraphWidget(cellWidget.childWidgets[k]);
                    }
                }
            }
        }
    }
    triggerWidgets(page) {
        if (page.headerWidget) {
            this.triggerHFWidgets(page, page.headerWidgetIn);
        }
        if (page.footerWidget) {
            this.triggerHFWidgets(page, page.footerWidgetIn);
        }
        /* eslint-disable */
        for (let i = 0; i < page.bodyWidgets.length; i++) {
            if (!isNullOrUndefined(page.bodyWidgets[i].floatingElements)) {
                this.triggerFloatingItems(page, page.bodyWidgets[i].floatingElements, 'Behind');
            }
        }
        /* eslint-enable */
        for (let i = 0; i < page.bodyWidgets.length; i++) {
            this.trigger(page, page.bodyWidgets[parseInt(i.toString(), 10)]);
            if (page.footnoteWidget && this.documentHelper.owner.layoutType === 'Pages') {
                this.triggerFootNoteWidget(page, page.footnoteWidget);
            }
        }
        if (page.endnoteWidget && this.documentHelper.owner.layoutType === 'Pages') {
            this.triggerFootNoteWidget(page, page.endnoteWidget);
        }
    }
    triggerHFWidgets(page, widget) {
        this.triggerFloatingItems(page, widget.floatingElements, 'Behind');
        for (let i = 0; i < widget.childWidgets.length; i++) {
            const block = widget.childWidgets[parseInt(i.toString(), 10)];
            this.triggerWidget(block);
        }
        this.triggerFloatingItems(page, widget.floatingElements, 'InFrontOfText');
    }
    triggerFloatingItems(page, floatingElements, wrappingType) {
        if (!isNullOrUndefined(floatingElements) && floatingElements.length > 0) {
            const overLappedShapeWidgets = new Dictionary();
            /* eslint-disable */
            floatingElements.sort(function (a, b) {
                if (a instanceof TableWidget || b instanceof TableWidget) {
                    return 0;
                }
                else {
                    return a.zOrderPosition - b.zOrderPosition;
                }
            });
            for (let i = 0; i < floatingElements.length; i++) {
                if (floatingElements[i] instanceof TableWidget) {
                    continue;
                }
                let shape = floatingElements[i];
                if ((wrappingType === "Behind" && shape.textWrappingStyle !== "Behind") ||
                    (wrappingType !== "Behind" && shape.textWrappingStyle === "Behind")) {
                    continue;
                }
                if (!this.documentHelper.render.isOverLappedShapeWidget(shape) || overLappedShapeWidgets.containsKey(shape.zOrderPosition)) {
                    if (shape instanceof ShapeElementBox) {
                        this.triggerShapeElementBox(shape, page);
                    }
                    else if (shape instanceof GroupShapeElementBox) {
                        this.triggerGroupShapeElementBox(shape, page);
                    }
                }
                else if (!overLappedShapeWidgets.containsKey(shape.zOrderPosition)) {
                    overLappedShapeWidgets.add(shape.zOrderPosition, shape);
                }
            }
            if (overLappedShapeWidgets.length > 0) {
                let sortedOverLappedShapeWidgets = overLappedShapeWidgets.keys.sort();
                for (let j = 0; j < sortedOverLappedShapeWidgets.length; j++) {
                    let shape = overLappedShapeWidgets.get(sortedOverLappedShapeWidgets[j]);
                    if (shape instanceof ShapeElementBox) {
                        this.triggerShapeElementBox(shape, page);
                    }
                    else if (shape instanceof GroupShapeElementBox) {
                        this.triggerGroupShapeElementBox(shape, page);
                    }
                }
            }
        }
    }
    triggerShapeElementBox(shape, page) {
        if (shape.isHorizontalRule) {
            return;
        }
        let blocks = shape.textFrame.childWidgets;
        for (let i = 0; i < blocks.length; i++) {
            this.triggerWidget(blocks[i]);
        }
    }
    triggerWidget(widget) {
        if (widget instanceof ParagraphWidget) {
            this.triggerParagraphWidget(widget);
        }
        else {
            this.triggerTableWidget(widget);
        }
    }
    trigger(page, bodyWidget) {
        for (let i = 0; i < bodyWidget.childWidgets.length; i++) {
            const widget = bodyWidget.childWidgets[parseInt(i.toString(), 10)];
            this.triggerWidget(widget);
        }
        for (let i = 0; i < page.bodyWidgets.length; i++) {
            if (!isNullOrUndefined(page.bodyWidgets[i].floatingElements)) {
                this.triggerFloatingItems(page, page.bodyWidgets[i].floatingElements, 'InFrontOfText');
            }
        }
    }
    triggerGroupShapeElementBox(groupShape, page) {
        for (let i = 0; i < groupShape.childWidgets.length; i++) {
            let shape = groupShape.childWidgets[i];
            if (shape instanceof GroupShapeElementBox) {
                this.triggerGroupShapeElementBox(shape, page);
            }
            else if (shape instanceof ShapeElementBox) {
                this.triggerShapeElementBox(shape, page);
            }
        }
    }
    triggerFootNoteWidget(page, footnote) {
        for (let i = 0; i < footnote.bodyWidgets.length; i++) {
            let bodyWidget = footnote.bodyWidgets[i];
            for (let j = 0; j < bodyWidget.childWidgets.length; j++) {
                let widget = bodyWidget.childWidgets[j];
                this.triggerWidget(widget);
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.errorWordCollection = undefined;
        this.ignoreAllItems = undefined;
        this.errorSuggestions = undefined;
        this.uniqueWordsCollection = undefined;
        this.uniqueSpelledWords = {};
        this.textSearchResults = undefined;
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
        this.documentHelper = undefined;
        this.handleErrorElements = [];
        this.pageCacheIndex = [];
    }
}
